import {
    ItemResponseSavedReportListItemBeanObject,
    ListResponseSavedReportListItemBean,
    SavedReportBean,
    SavedReportControllerApi
} from 'src/api/api'
import {BaseApi, configuration} from '../../../api/BaseApi'

class SavedReportApi extends BaseApi {
    api: SavedReportControllerApi

    constructor() {
        super()
        this.api = new SavedReportControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(size: number = 20, page: number = 1, sort, search): Promise<ListResponseSavedReportListItemBean> {
        return this.call(() => this.api.savedReportList(search, { query: { size, page, sort } }))
    }

    all(): Promise<ListResponseSavedReportListItemBean> {
        return this.call(() => this.api.savedReportList())
    }

    create(campaign: SavedReportBean): Promise<ItemResponseSavedReportListItemBeanObject> {
        return this.call(() => this.api.createSavedReport(campaign))
    }

    edit(id: any, bean: SavedReportBean): Promise<ItemResponseSavedReportListItemBeanObject> {
        return this.call(() => this.api.editSavedReport(bean, id))
    }

    view(id: any): Promise<ItemResponseSavedReportListItemBeanObject> {
        return this.call(() => this.api.getSavedReport(id))
    }

    delete(id: number): Promise<void> {
        return this.call(() => this.api.deleteSavedReport(id))
    }
}

const savedReportApi = new SavedReportApi()
export default savedReportApi


// WEBPACK FOOTER //
// ./src/component/app/saved-report/SavedReportApi.ts